(function() {
    'use strict';

    /**
     * Contrôleur pour la page d'inscription
     */
    angular
        .module('observatoireApp')
        .controller('RegisterController', ['$scope', '$state', 'Auth', '$window', '$http', '$timeout', function($scope, $state, Auth, $window, $http, $timeout) {
            $scope.user = {};
            $scope.errors = {};
            $scope.loading = false;
            $scope.captchaToken = null;

            // ── Cloudflare Turnstile ──────────────────────────────────────
            // Clé de test Cloudflare (toujours valide en dev).
            // Remplacez par votre vraie clé sur https://dash.cloudflare.com/ > Turnstile
            var TURNSTILE_SITE_KEY = '0x4AAAAAADCmKel9mPdjC1ku';

            function renderTurnstile() {
                var container = document.getElementById('cf-turnstile-container');
                if (!container || container.children.length > 0) return;
                if ($window.turnstile) {
                    $window.turnstile.render('#cf-turnstile-container', {
                        sitekey: TURNSTILE_SITE_KEY,
                        theme: 'light',
                        language: 'fr',
                        callback: function(token) {
                            $scope.$apply(function() { $scope.captchaToken = token; });
                        },
                        'expired-callback': function() {
                            $scope.$apply(function() { $scope.captchaToken = null; });
                        },
                        'error-callback': function() {
                            $scope.$apply(function() { $scope.captchaToken = null; });
                        }
                    });
                }
            }

            // Attendre que le script Turnstile soit chargé (async)
            $timeout(renderTurnstile, 300);

            // Fonction pour rediriger vers la page de connexion
            $scope.goToLogin = function() {
                $state.go('login');
            };

            // Si l'utilisateur est déjà connecté, rediriger vers la page d'accueil
            if (Auth.isAuthenticated()) {
                $state.go('main.home');
            }

            // Fonction d'inscription
            $scope.register = function(form) {
      $scope.submitted = true;
      $scope.loading = true;

      if (form.$valid) {
        // Assurez-vous que les mots de passe correspondent
        if ($scope.user.password !== $scope.user.confirmPassword) {
          $scope.errors.password = 'Les mots de passe ne correspondent pas';
          $scope.loading = false;
          return;
        }

        console.log('Tentative d\'inscription avec les données:', {
          username: $scope.user.username,
          email: $scope.user.email,
          firstName: $scope.user.firstName,
          lastName: $scope.user.lastName,
          // Ne pas loguer le mot de passe pour des raisons de sécurité
        });

        // Vérification anti-robot
        if (!$scope.captchaToken) {
          $scope.errors.register = 'Veuillez compléter la vérification anti-robot.';
          $scope.loading = false;
          return;
        }

        // Utiliser directement $http comme dans le contrôleur de test qui fonctionne
        var userData = {
          username: $scope.user.username,
          email: $scope.user.email,
          password: $scope.user.password,
          firstName: $scope.user.firstName,
          lastName: $scope.user.lastName,
          captchaToken: $scope.captchaToken
        };
        
        console.log('Envoi direct des données:', userData);
        
        // Configurer $http pour accepter les réponses textuelles et pas seulement JSON
        $http.post('/api/auth/signup', userData, {
          transformResponse: function(data) {
            // Ne pas essayer de parser comme JSON, retourner tel quel
            return {success: true, message: data};
          }
        })
        .then(function(response) {
          console.log('Inscription réussie (appel direct):', response.data);
          // Redirection vers la page de connexion avec un message de succès
          $scope.loading = false;
          $state.go('login', { registered: true });
        })
        .catch(function(err) {
          console.error('Erreur lors de l\'inscription (appel direct):', err);
          if (err.data) { console.error('Détails de l\'erreur:', err.data); }
          $scope.errors.register = err.data && err.data.message ? err.data.message : 'Une erreur est survenue lors de l\'inscription';
          $scope.loading = false;
          // Réinitialiser le captcha après erreur
          $scope.captchaToken = null;
          if ($window.turnstile) { $window.turnstile.reset('#cf-turnstile-container'); }
        });
      } else {
        $scope.loading = false;
      }
    };
  }]);
})();
